module.exports = __webpack_public_path__ + "static/media/expired_status_icon.6ab19f67.svg";